import React, { createContext, useState, useEffect, useCallback, useContext } from "react";

export const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [state, setState] = useState(undefined); // undefined = pas encore chargé
  const [loading, setLoading] = useState(true);
  const [accessibleUsers, setAccessibleUsers] = useState([]); // liste des utilisateurs suivis en tant que proche

  const fetchAccessibleUsers = useCallback(async () => {
    try {
      const res = await fetch("/api/proche/access", { credentials: "include" });
      if (res.ok) {
        const data = await res.json();
        setAccessibleUsers(data);
      } else {
        setAccessibleUsers([]);
      }
    } catch {
      setAccessibleUsers([]);
    }
  }, []);

  // Restauration de session au chargement
  useEffect(() => {
    setLoading(true);
    fetch("/api/me", { method: "GET", credentials: "include" })
      .then((res) => (res.ok ? res.json() : null))
      .then((data) => setState(data))
      .catch(() => setState(null))
      .finally(() => setLoading(false));
  }, []); // eslint-disable-line

  // Fetch les utilisateurs accessibles dès qu'on est connecté
  useEffect(() => {
    if (state) {
      fetchAccessibleUsers();
    } else {
      setAccessibleUsers([]);
    }
  }, [state, fetchAccessibleUsers]);

  const refreshUser = useCallback(async () => {
    try {
      const res = await fetch("/api/me", { method: "GET", credentials: "include" });
      if (!res.ok) throw new Error("Not logged in");
      const data = await res.json();
      setState(data);
    } catch {
      // ne pas déconnecter sur une erreur réseau passagère
    }
  }, []);

  const logout = useCallback(() => {
    setState(null);
    setAccessibleUsers([]);
  }, []);

  return (
    <AuthContext.Provider value={{ state, setState, loading, refreshUser, logout, accessibleUsers, fetchAccessibleUsers }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
